// Backlog 128 (vault #367): polls knktr-queue-stats every 10 s while the tab
// is visible; pauses when hidden (no reads nobody sees). A failed read keeps
// the last good figures until they go stale (lib/queueStats.js STALE_MS),
// then the header shows dashes again. Kept out of ConsoleHeader.jsx so the
// header itself stays fetch-free (verify-v3-header).
import { useEffect, useState } from 'react';
import { apiHeaders } from '../lib/consoleApi';
import { fetchQueueStats, POLL_MS } from '../lib/queueStats';

const QUEUE_STATS_URL = import.meta.env.VITE_QUEUE_STATS_URL || '';

export function useQueueStats() {
  const [data, setData] = useState(null);
  const [tick, setTick] = useState(0);   // re-renders so staleness is re-checked
  useEffect(() => {
    if (!QUEUE_STATS_URL || typeof document === 'undefined') return undefined;
    let live = true;
    let timer = null;
    const read = async () => {
      if (document.visibilityState === 'hidden') return;
      const got = await fetchQueueStats({ url: QUEUE_STATS_URL, headers: await apiHeaders() });
      if (!live) return;
      if (got) setData(got);
      setTick(t => t + 1);
    };
    read();
    timer = setInterval(read, POLL_MS);
    const onVis = () => { if (document.visibilityState === 'visible') read(); };
    document.addEventListener('visibilitychange', onVis);
    return () => { live = false; clearInterval(timer); document.removeEventListener('visibilitychange', onVis); };
  }, []);
  // Smooth timer: while anyone is waiting, re-render once a second so the
  // longest wait counts up between reads (lib/queueStats.js liveWaitSec).
  const waiting = (data?.totals?.waiting ?? 0) > 0;
  useEffect(() => {
    if (!waiting) return undefined;
    const t = setInterval(() => setTick(x => x + 1), 1000);
    return () => clearInterval(t);
  }, [waiting]);
  return { data, tick };
}
